module.exports = __webpack_public_path__ + "img/cu_logo.5674c9a2.png";